import { Check, X, Home, Package, EyeOff, Trash2, RotateCcw, MessageCircle, PauseCircle, Ban, PlayCircle, ShieldCheck, BadgeCheck, Pencil, UserPlus, Plus, Megaphone, Clock, Star, Pin } from "lucide-react";

export const SELLER_TYPES = ["Individual", "Breeder", "Business", "Shelter"];

export const ACTION_META = {
  listing_approved: { label: "Approved ad", icon: Check, color: "#10B981" },
  listing_rejected: { label: "Rejected ad", icon: X, color: "#DC2626" },
  listing_edit_approved: { label: "Approved ad edit", icon: Check, color: "#10B981" },
  listing_edit_rejected: { label: "Rejected ad edit", icon: X, color: "#DC2626" },
  hero_updated: { label: "Updated homepage text", icon: Home, color: "#0EA5E9" },
  categories_updated: { label: "Updated category tiles", icon: Package, color: "#0EA5E9" },
  listing_removed: { label: "Removed ad", icon: EyeOff, color: "#64748B" },
  listing_deleted: { label: "Deleted ad", icon: Trash2, color: "#DC2626" },
  listing_delete_undone: { label: "Undid ad deletion", icon: RotateCcw, color: "#10B981" },
  listing_restored: { label: "Restored ad", icon: RotateCcw, color: "#0EA5E9" },
  message_sent: { label: "Messaged user", icon: MessageCircle, color: "#F5551E" },
  user_suspended: { label: "Suspended user", icon: PauseCircle, color: "#F59E0B" },
  user_blocked: { label: "Blocked user", icon: Ban, color: "#DC2626" },
  user_active: { label: "Reactivated user", icon: PlayCircle, color: "#10B981" },
  user_role_changed: { label: "Changed role", icon: ShieldCheck, color: "#12234A" },
  user_verified: { label: "Verified seller", icon: BadgeCheck, color: "#10B981" },
  user_unverified: { label: "Unverified seller", icon: BadgeCheck, color: "#64748B" },
  user_updated: { label: "Edited profile", icon: Pencil, color: "#0EA5E9" },
  user_deleted: { label: "Deleted user", icon: Trash2, color: "#DC2626" },
  user_created: { label: "Created user", icon: UserPlus, color: "#10B981" },
  listing_created: { label: "Created ad", icon: Plus, color: "#10B981" },
  broadcast_sent: { label: "Sent announcement", icon: Megaphone, color: "#7C3AED" },
  broadcast_scheduled: { label: "Scheduled announcement", icon: Clock, color: "#7C3AED" },
  listing_reinstated: { label: "Reinstated ad", icon: RotateCcw, color: "#10B981" },
  listing_featured: { label: "Featured ad", icon: Star, color: "#F5551E" },
  listing_unfeatured: { label: "Unfeatured ad", icon: Star, color: "#64748B" },
  listing_pinned: { label: "Pinned ad", icon: Pin, color: "#12234A" },
  listing_unpinned: { label: "Unpinned ad", icon: Pin, color: "#64748B" },
};

export const timeAgo = (iso) => {
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return new Date(iso).toLocaleDateString();
};

export const STATUS_STYLE = {
  active: "bg-emerald-600", suspended: "bg-amber-500", blocked: "bg-red-600",
};
